import AnimationStyles from './AnimationStyles';
import AntdOverrides from './AntdOverrides';
import AppShellStyles from './AppShellStyles';
import DocumentStyles from './DocumentStyles';
import FontStyles from './FontStyles';
import GoogleMapsStyles from './GoogleMapsStyles';
import ScrollbarsStyles from './ScrollbarsStyles';
import TypographyGlobalStyles from './TypographyGlobalStyles';

export default function GlobalStyles() {
  return (
    <>
      <AppShellStyles />
      <DocumentStyles />
      <FontStyles />
      <AntdOverrides />
      <GoogleMapsStyles />
      <AnimationStyles />
      <ScrollbarsStyles />
      <TypographyGlobalStyles />
    </>
  );
}
